import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/aftercare/")({
  component: AftercareIndex,
});

function AftercareIndex() {
  const { group_id } = Route.useParams();
  // Redirect to the first subsection (weights)
  return <Navigate to="/fermentations/$group_id/aftercare/weights" params={{ group_id }} replace />;
}

